import {
    createActionTypeFactory,
    createNamespaceActionCreatorFactory,
    createNamespaceReducerFactory,
    createNamespaceSelectorFactory,
    IActionReducerFactory,
    IActionTypeFactory,
    INamespaceActionCreatorFactory,
    ISelectorFactory,
} from '@omaze/redux';

import { ISnackbarState } from './Snackbar.state';

export const SNACKBAR_NAMESPACE: string = 'snackbar';

export const createSnackbarActionType: IActionTypeFactory =
    createActionTypeFactory(SNACKBAR_NAMESPACE);

export const createSnackbarActionCreatorFactory: INamespaceActionCreatorFactory =
    createNamespaceActionCreatorFactory(SNACKBAR_NAMESPACE);

export const createSnackbarReducerFactory: IActionReducerFactory<ISnackbarState> =
    createNamespaceReducerFactory<ISnackbarState>(SNACKBAR_NAMESPACE);

export const createSnackbarSelector: ISelectorFactory<ISnackbarState> =
    createNamespaceSelectorFactory<ISnackbarState>(SNACKBAR_NAMESPACE);
